import { Add, Close, Edit, SwipeUp } from '@mui/icons-material';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Form, Spin } from 'antd';
import ButtonMui from '@mui/material/Button';
import Billetage from '../../../Billetage';
import InputForm from '../../../InputT';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import Data from "../../../../Data/Data.json";
import SweetAlert from "sweetalert2";
import OperationCaisse from '../../../../Models/OperationCaisse';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import axios from 'axios';
import { useAuthUser, useAuthHeader } from '../../../../Services/Auth/sessionAuth';
import { Crypter } from '../../../../Functions/Security/Crypter';
import Utilisateur from '../../../../Models/Utilisateur';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import { useNavigate } from 'react-router-dom';
import { apiEndpoints } from '../../../../config';
import { formatCurrency, PrintRecuCaisseDirect } from '../../../../utilitaires/globalFunction';


export default function ReceptionAgent(props: { form: any, disabled: boolean, codeSecret: string }) {
    const [open, setOpen] = React.useState(false);
    const [isOk, setIsOk] = useState<boolean>(false)
    const { register, handleSubmit } = useForm()
    const [fichier, setFicher] = useState<File>()
    const [loading, setLoading] = useState<boolean>(false)
    const navigate = useNavigate()


    // USER SESSION
    const auth = useAuthUser()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

    // USER TOKEN
    const authHeader = useAuthHeader()

    const handleClickOpen = () => {
        //alert(props.form.getFieldValue("CODCONFIDENCE"))

        if (props.form.getFieldValue("CODCONFIDENCE") && props.form.getFieldValue("CODCONFIDENCE") != "") {
            if (props.form.getFieldValue("CODCONFIDENCE") == props.codeSecret) {
                setOpen(true);
                props.form.setFieldsValue(props.form)
                getToatal()
            } else {
                SweetAlert.fire({ title: "Code sécrêt de l'opération incorect", icon: "warning" })
            }
        } else {
            SweetAlert.fire({ title: "Veillez renseigner le code sécrêt de l'opération", icon: "warning" })
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const onFinish = () => {
        props.form.setFieldValue("CODOPE1", "983")
        if (props.form.getFieldValue("montantOpe") == ReformatNumber(props.form.getFieldValue("TotalBilletage"))) {
            var op: OperationCaisse = props.form.getFieldValue()

            op.TypeOpe = props.form.getFieldValue("TypeOpe")
            op.NODECE = props.form.getFieldValue("NODECE")
            op.CAIUTI = props.form.getFieldValue("CAIUTI")
            op.UTISAI = user.coduti
            //alert(op.DISPON)
            op.DISPON = ReformatNumber(op.DISPON + "")
            op.UTISAI = user.coduti
            //alert(op.DISPON)
            op.DateDeliv = '2016-10-06 00:00:00.000'
            op.DateOpe = '2016-10-06 00:00:00.000'
            op.DateVal = '2016-10-06 00:00:00.000'
            op.CODAGE = user.codage
            op.AGCEDEPART = user.codage

            op.CODOPE = '983'
            op.TypeOpe = 'REC'
            let value = op.TypeOpe

            //alert(op.DateDeliv)


            //console.log(op)
            SweetAlert.fire({
                title: ((value == 'VER') ? "VERSEMENT" : (value == 'RET') ? "RETRAIT" : (value == 'ENV') ? "ENVOI D'ARGENT" : "RECEPTION D'ARGENT ") + " " + " de " + formatNumber(parseInt(op.montantOpe)) + " XAF\nPar " + op.nombene + "\nCompte : \n" + op.NUMCPT + ' (' + op.lib_NUMCPT + ')',
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: 'question'
            }).then((res) => {
                if (res.isConfirmed) {
                    try {

                        setLoading(true);

                        let config = {
                            method: 'post',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.OperationsCaisse,
                            headers: {
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                            data: Crypter.encrypt(JSON.stringify(op)),
                        };

                        axios.request(config)
                            .then((response) => {
                                setLoading(false);
                                if (response.data) {
                                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                                    //alert(res.StatutCode)
                                    if (res.StatutCode == 200) {
                                        SweetAlert.fire({ title: res.Message, icon: "success" })
                                        localStorage.setItem(Data.LocalVariable.reset, "1")
                                        setOpen(false)
                                        props.form.resetFields()

                                        //Impression Recu
                                        op.NUMRAP = res.Message.split(" : ")[1]

                                        op.CODOPE1 = op.CODOPE
                                        
                                        let data = { "form": op }
                                        localStorage.setItem(Data.LocalVariable.Recu, JSON.stringify(data))
                                       // navigate("/operation/Deposit&withdrawal/print")
                                      // navigate("/caisse/veresmentretrait/print")

                                         //handleDownloadRecuDirect(op.NODECE,op.NUMSEQ,op.UTISAI,op.lib_CODOPE,op.CDDEVS,op.lib_CDDEVS,op.CODOPE1,op.NUMCPT,Number(op.montantOpe),op.CDDEVS,"pdf")  
                                         PrintRecuCaisseDirect(user.codage,user.agence,user.nomuti, op.NODECE,op.NUMSEQ,op.UTISAI,op.lib_CODOPE,op.CDDEVS,op.lib_CDDEVS,op.CODOPE1,op.NUMCPT,Number(op.montantOpe),"pdf")


                                    }
                                    else if (res.StatutCode == 208) {
                                        //alert(JSON.stringify(res.Result.Table1))
                                        var UsersVal: { [name: string]: string } = {};

                                        res.Result.Table1.map((u: any) => {
                                            UsersVal[u.CODUTI] = u.CODUTI + " - " + u.NOMUTI
                                        })
                                        SweetAlert.fire({
                                            title: res.Message,
                                            text: "Voulez vous passez cette opération en litige?",
                                            showCancelButton: true,
                                            color: "#116599",
                                            confirmButtonText: "Yes",
                                            confirmButtonColor: "#116599",
                                            cancelButtonColor: "darkred",
                                            cancelButtonText: "No",
                                            showLoaderOnConfirm: true,
                                            input: 'select',
                                            inputOptions: UsersVal,
                                            inputPlaceholder: "Utilisateur qui dois valider l'opération",
                                            icon: 'warning'
                                        }).then((resp) => {

                                            if (resp.isConfirmed) {
                                                if (resp.value != null && resp.value != "") {
                                                    op.utival = resp.value
                                                    op.lib_CODOPE = op.lib_CODOPE + '|' + res.Message;
                                                    SendToLitige(op)
                                                } else {
                                                    SweetAlert.fire({ title: "Veillez sélectionner l'utilisateur qui doit valider l'opération", icon: "warning" })
                                                }
                                            }
                                        }).catch((error) => {
                                            setLoading(false);
                                            SweetAlert.fire({ title: error, icon: "error" })
                                        })
                                    }
                                    else {
                                        SweetAlert.fire({ title: res.Message, icon: "warning" })
                                    }
                                }
                            })
                            .catch((error) => {
                                setLoading(false);
                                console.log(error)
                                SweetAlert.fire({ title: error, icon: "error" })
                            })

                    } catch (error) {
                        SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
                    }
                }
            })
        } else {
            SweetAlert.fire({ title: 'Votre Bielletage est incorrect', icon: "warning" })
        }
    };

    const handleDownloadRecuDirect = async (Nodece: string, NumSeq: string, UtiSai: string, SensOpe: string, Devise: string, LibDevise: string, LibInfos: string, NumCpt: string, montantOpe: number, CDDEVS: string, format: string = "pdf") => {
      try {
        
        //setLoading(true);
        // let Nodece = form.getFieldValue("NODECE");
        // let NumSeq = form.getFieldValue("NUMSEQ");
        // let UtiSai = form.getFieldValue("UTISAI");
        let CodAgce = user?.codage || "";
        let Libelle = user.agence;
         let NomUser = user?.nomuti || "";
        // let SensOpe = form.getFieldValue("lib_CODOPE") || "";
        // let Devise = form.getFieldValue("lib_CDDEVS") || "XAF";
        // let LibInfos = form.getFieldValue("CODOPE1") || "";
        // let NumCpt=form.getFieldValue("NUMCPT") || ""
         let Montan=formatCurrency(montantOpe,Devise)//formatCurrency (form.getFieldValue("montantOpe") ?? "0",form.getFieldValue("CDDEVS") || "XAF")
        
       
        //alert(Montan)
    
    
        if (LibInfos=="950" || LibInfos=="050"){
          SensOpe="VERSEMENT ESPECES"
          LibInfos="Nous portons au crédit du compte: "+NumCpt+ " la somme de :"+ Montan+" "+ LibDevise;
        }
        if (LibInfos=="951" || LibInfos=="051"){
           SensOpe="RETRAIT ESPECES"
          LibInfos="Nous portons au débit du compte: "+NumCpt+ " la somme de :"+ Montan+" "+ LibDevise;
        }
     
         
     
        
    
        // const op: OperationCaisse = form.getFieldsValue();
        // console.log(op)
        // op.DISPON = ReformatNumber(form.getFieldValue("DISPON") ?? "0");
        // op.NODECE = form.getFieldValue("NODECE");
        // op.UTISAI = form.getFieldValue("UTISAI");
        // op.CODAGE = form.getFieldValue("CODAGE");
        // op.NUMSEQ = form.getFieldValue("NUMRAP");
    
        const response = await axios.get(`${apiEndpoints.fastReport}/PrintRecuCaisse`, {
              params: {
                CodAgce,Libelle,Nodece, NumSeq, UtiSai,NomUser,SensOpe,Devise,LibInfos
              },
              responseType: 'blob',
            });
    
        if (response.data) {
          // alert( response.data);
          const blob = new Blob([response.data], { type: "application/pdf" });
          const now = new Date();
          const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
          const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-"); // remplace ":" pour éviter les problèmes de nom de fichier
          const fileName = `PrintRecuCaisse_${NumSeq}_${UtiSai}_${formattedDate}_${formattedTime}.${format}`;
    
          //const fileName = `PrintRecuCaisse_${NumSeq}_${UtiSai}_${new Date().toLocaleTimeString("fr-FR").replace(/\//g, "-")}.${format}`;
          // const url = window.URL.createObjectURL(blob);
          // const link = document.createElement("a");
          // link.href = url;
          // link.setAttribute("download", fileName);
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);
          // window.URL.revokeObjectURL(url);
    
    //       const file = new File([blob], fileName, { type: "application/pdf" });
    //       const url = URL.createObjectURL(file);
    //       const previewHtml = `
    //   <html>
    //     <head>
    //       <title>${fileName}</title>
    //     </head>
    //     <body style="margin:0">
    //       <iframe src="${url}" width="100%" height="100%" style="border:none;"></iframe>
    //     </body>
    //   </html>
    // `;
    
    // const previewBlob = new Blob([previewHtml], { type: "text/html" });
    // const previewUrl = URL.createObjectURL(previewBlob);
    // window.open(previewUrl, '_blank');
    //window.open(url, '_blank');
    
          //const url = window.URL.createObjectURL(blob);
          //window.open(url, '_blank'); // Ouvre le PDF dans un nouvel onglet pour prévisualisation
      const url = window.URL.createObjectURL(blob);
    //       SweetAlert.fire({
    //   title: "Reçu généré",
    //   text: "Souhaitez-vous prévisualiser ou télécharger le reçu ?",
    //   icon: "question",
    //   showCancelButton: true,
    //   confirmButtonText: "Prévisualiser",
    //   cancelButtonText: "Télécharger"
    // }).then((result) => {
      
    //   if (result.isConfirmed) {
    //     window.open(url, '_blank'); // Prévisualisation
    //   } else {
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.setAttribute("download", fileName);
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //     window.URL.revokeObjectURL(url);
        
    //   }
    // });
    
    //   setTimeout(() => {
    //       window.URL.revokeObjectURL(url);
    //       }, 10000);     
    
    SweetAlert.fire({
      title: "Reçu généré",
      text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le reçu ?",
      icon: "question",
      showCancelButton: true,
      showDenyButton: true,
      denyButtonText: "Imprimer",
      confirmButtonText: "Prévisualiser",
      cancelButtonText: "Télécharger"
    }).then((result) => {
      const file = new File([blob], fileName, { type: "application/pdf" });
      const url = URL.createObjectURL(file);
    
      if (result.isConfirmed) {
        // ✅ Prévisualiser
        window.open(url, '_blank');
      } else if (result.isDenied) {
        // ✅ Imprimer directement via iframe
        const printHtml = `
          <html>
            <head>
              <title>${fileName}</title>
              <style>
                html, body {
                  margin: 0;
                  height: 100%;
                }
                iframe {
                  width: 100%;
                  height: 100%;
                  border: none;
                }
              </style>
            </head>
            <body>
              <iframe id="pdfFrame" src="${url}"></iframe>
              <script>
                const iframe = document.getElementById('pdfFrame');
                iframe.onload = function() {
                  setTimeout(() => {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                  }, 500);
                };
              </script>
            </body>
          </html>
        `;
        const printBlob = new Blob([printHtml], { type: "text/html" });
        const printUrl = URL.createObjectURL(printBlob);
        window.open(printUrl, '_blank');
      } else {
        // ✅ Télécharger
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    
      // Nettoyage après quelques secondes
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 10000);
    });
    
        }else{
          SweetAlert.fire({ title: "Erreur", text: String("Erreur lors du téléchargement du fichier :"), icon: "error" });
        }
    
       // setLoading(false);
    
      } catch (error) {
       // setLoading(false);
        console.error("Erreur lors du téléchargement du fichier :", error);
        SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
      }
    };

    function SendToLitige(op: OperationCaisse) {
        try {
            setLoading(true);

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.SendToLitige,
                headers: {
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                },
                data: Crypter.encrypt(JSON.stringify(op)),
            };

            axios.request(config)
                .then((response) => {
                    setLoading(false);
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                        if (res.StatutCode == 200) {
                            SweetAlert.fire({ title: res.Message, icon: "success" })
                            localStorage.setItem(Data.LocalVariable.reset, "1")
                            setOpen(false)
                            props.form.resetFields()

                        }
                        else {
                            SweetAlert.fire({ title: res.Message, icon: "warning" })
                        }
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    console.log(error)
                    SweetAlert.fire({ title: error, icon: "error" })
                })

        } catch (error) {
            SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
        }

    }


    function getToatal() {
        props.form.setFieldValue('TotalBilletage',
            formatNumber(
                parseInt((props.form.getFieldValue("NOMB01") ? props.form.getFieldValue("NOMB01") : 0)) * 10000 +
                parseInt((props.form.getFieldValue("NOMB02") ? props.form.getFieldValue("NOMB02") : 0)) * 5000 +
                parseInt((props.form.getFieldValue("NOMB03") ? props.form.getFieldValue("NOMB03") : 0)) * 2000 +
                parseInt((props.form.getFieldValue("NOMB04") ? props.form.getFieldValue("NOMB04") : 0)) * 1000 +
                parseInt((props.form.getFieldValue("NOMB05") ? props.form.getFieldValue("NOMB05") : 0)) * 500 +
                parseInt((props.form.getFieldValue("NOMB06") ? props.form.getFieldValue("NOMB06") : 0)) * 500 +
                parseInt((props.form.getFieldValue("NOMB07") ? props.form.getFieldValue("NOMB07") : 0)) * 100 +
                parseInt((props.form.getFieldValue("NOMB08") ? props.form.getFieldValue("NOMB08") : 0)) * 50 +
                parseInt((props.form.getFieldValue("NOMB09") ? props.form.getFieldValue("NOMB09") : 0)) * 25 +
                parseInt((props.form.getFieldValue("NOMB10") ? props.form.getFieldValue("NOMB10") : 0)) * 10 +
                parseInt((props.form.getFieldValue("NOMB11") ? props.form.getFieldValue("NOMB11") : 0)) * 5 +
                parseInt((props.form.getFieldValue("NOMB12") ? props.form.getFieldValue("NOMB12") : 0)) * 2 +
                parseInt((props.form.getFieldValue("NOMB13") ? props.form.getFieldValue("NOMB13") : 0)) * 1)
        )
    }

    setTimeout(() => {
        try {
            let reset = localStorage.getItem(Data.LocalVariable.reset)
            if (reset == "1") {
                setOpen(false)
            }
        }
        catch (error) { }
    }, .1)
    return (
        <div>
            <Button size='large' className='bt_add' disabled={props.disabled} type="ghost" onClick={handleClickOpen} block>
                Reception
            </Button>

            {/* <Tooltip title={props.title} >
                <ButtonMui style={{borderBottomRightRadius: "0px", borderBottomLeftRadius: "0px"}} color='success' onClick={handleClickOpen}>C</ButtonMui>
            </Tooltip> */}

            <Dialog maxWidth={false} open={open} style={{ zIndex: 1, marginLeft: "12%" }} onClose={handleClose} aria-labelledby="form-dialog-title">
                <Box height={30} display={'flex'}>
                    <DialogTitle textAlign={"center"} id="form-dialog-title"><b>Reception d'argent . . .</b></DialogTitle>
                    <hr color='white' />
                    <ButtonMui variant='outlined' style={{ boxShadow: "none" }} color='error' size='small' onClick={handleClose} ><Close /></ButtonMui>
                </Box>
                <DialogContent>
                    <Billetage withTatal />
                </DialogContent>
                <DialogActions style={{ marginTop: "-2.5%" }}>
                    <Button loading={loading} onClick={onFinish} size='large' className='bt_add' type="ghost" htmlType="submit" block>
                        Enregistrer
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
